import { useState } from 'react'
import dayjs from 'dayjs'
import { useTheme } from '@mui/material/styles'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import 'dayjs/locale/it'

import { colours } from '../settings/settings'

const MyDatePicker = ({
  value,
  onChange,
  autoFocus = false,
  disabled = false,
  disablePast = false,
  disableFuture = false,
  error = false,
  readOnly = false,
  label = '',
  variant = 'filled',
  onlyDays,
}) => {
  const [validationError, setValidationError] = useState()

  const theme = useTheme()
  const errTextColor = theme.palette.error.main
  const errBackColor = colours.redError

  const disableDays = x => onlyDays && !onlyDays?.includes(x?.day())

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='it'>
      <DatePicker
        value={
          value && dayjs(value, 'DD/MM/YYYY')?.isValid()
            ? dayjs(value, 'DD/MM/YYYY')
            : null
        }
        onChange={i => onChange && onChange(i?.format('DD/MM/YYYY'))}
        onError={i => setValidationError(!!(error || i))}
        autoFocus={!!autoFocus}
        closeOnSelect={true}
        disabled={!!disabled}
        disablePast={!!disablePast}
        disableFuture={!!disableFuture}
        shouldDisableDate={disableDays}
        readOnly={!!readOnly}
        label={label}
        format='DD/MM/YYYY'
        localeText={{
          fieldClearLabel: 'Cancella',
          clearButtonLabel: 'Cancella',
          cancelButtonLabel: 'Annulla',
          datePickerToolbarTitle: 'Seleziona data',
        }}
        slotProps={{
          actionBar: { actions: ['cancel'] },
          textField: {
            variant,
            clearable: true,
            fullWidth: true,
            error: error || validationError,
            sx: {
              '& .MuiPickersInputBase-root': {
                color: (error || validationError) && errTextColor,
                backgroundColor:
                  (disabled && 'transparent') ||
                  ((error || validationError) && errBackColor),
              },
            },
          },
        }}
      />
    </LocalizationProvider>
  )
}

export default MyDatePicker
